"use client";
import { NftActivities } from "./types";
import { NftActivityDescripitonItem } from "../NftActivityDescriptionItem";
import { Activity } from "@/api/activities/types";
import usePaymentCurrency from "@/shared/hooks/usePaymentCurrency";
import { getDisplayPrice } from "@/shared/currencies";
import { getUsersName } from "@/api/users/helpers";
import { ArgKeys, ActivityConfigType } from "./types";

export interface Props {
  activity: Activity;
  activityConfig: ActivityConfigType;
}

const NftActivityDescription = ({ activity, activityConfig }: Props) => {
  const {
    type,
    initiator,
    from,
    to,
    price,
    totalPrice,
    paymentErc20TokenAddress,
  } = activity;
  const paymentMethod = usePaymentCurrency(paymentErc20TokenAddress);

  const config = activityConfig[type as NftActivities];
  if (!config) return null;

  const args = config.args?.map((arg: ArgKeys) => {
    switch (arg) {
      case "initiator":
        return {
          user: initiator,
          text: getUsersName(initiator, true),
          link: true,
        };
      case "from":
        return {
          text: getUsersName(from, true),
          user: from,
          link: true,
        };
      case "to":
        return {
          user: to,
          text: getUsersName(to, true),
          link: true,
        };
      case "price":
        return { text: getDisplayPrice(price, paymentMethod?.decimals) };
      case "totalPrice":
        return { text: getDisplayPrice(totalPrice, paymentMethod?.decimals) };
      case "paymentLabel":
        return { text: paymentMethod?.label };
      default:
        return {};
    }
  });

  return <NftActivityDescripitonItem text={config.text} args={args} />;
};

export default NftActivityDescription;
